import React from 'react'
import styled from 'styled-components'
import { Icon } from '@nvidia/kaizen-ui'
import ngcLogo from '../../images/powered-by-ngc.svg'

const StyledFooter = styled.footer`
  background-color: #424242;
  width:100%;
  padding: 28px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 600px) {
    padding: 14px;
  }
`

const Logo = styled.img`
  @media (max-width: 600px) {
    width: 45%;
  }
`

const Legal = styled.div`
  & a,
  & a:visited,
  & p {
    color: #FAFAFA;
    font-size: 14px;
    line-height: 14px;
    text-decoration: none;
    margin-bottom: 14px;
  }

  & p {
    font-size: 12px;
    line-height: 15px;
  }

  i {
    margin-left: 7px;
  }

  @media only screen and (max-width: 600px) {
    & a {
      margin-bottom: 7px;
    }

    & a,
    & p {
      font-size: 8px;
    }
  }
`

export const Footer = () =>
  <StyledFooter>
    <Logo src={ngcLogo} alt='NVIDIA GPU Cloud' />
    <Legal>
      <a href='https://www.nvidia.com/en-us/about-nvidia/privacy-policy/'>Privacy & Terms of Use<br /></a>
      <a href='mailto:researchinquiries@nvidia.com'>Research Inquiries<Icon small name='email-fill' /></a>
      <p>&copy; 2018 NVIDIA Corporation</p>
    </Legal>
  </StyledFooter>



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js